import React from 'react';
import { useDispatch } from 'react-redux';

import Button from '@/src/components/common/Elements/Button/Button';
import { deleteCommentFromApi } from '@/src/reducers/project/comments/comments.actions.js';
import { cn } from '@/src/util/ui';

const Delete = ({ comment, className = '' }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteCommentFromApi(comment.id, comment.commentGroup));
  };

  return (
    <Button className={cn(className)} onClick={handleDelete}>
      Delete
    </Button>
  );
};

export default Delete;
